import { Component, OnInit } from '@angular/core';
declare const maps: any;

@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.css']
})
export class HistoriqueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    //maps();
  }

}
